import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  location: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    cursor: 'pointer',

    '& > .viboIcon': {
      fontSize: '14px!important',

      '@media screen and (min-width: 1441px)': {
        fontSize: '16px!important',
      },
    },

    '& > .name': {
      ...mixins.longText,
    },
  },
}));

export default useStyles;
